"use client";

import { c as _c } from "react/compiler-runtime";
import { useModalStore } from "../../../global-account/react/index.js";
import { useEffect } from "react";
/**
 * Handles Stripe payment redirects by showing the order details modal
 * when returning from Stripe's payment flow.
 *
 * This component should be mounted inside AnyspendProvider to ensure
 * proper modal state management.
 */
export function StripeRedirectHandler() {
  const $ = _c(4);
  const setB3ModalOpen = useModalStore(_temp);
  const setB3ModalContentType = useModalStore(_temp2);
  let t0;
  let t1;
  if ($[0] !== setB3ModalContentType || $[1] !== setB3ModalOpen) {
    t0 = () => {
      const url = new URL(window.location.href);
      const fromStripe = url.searchParams.get("fromStripe");
      const paymentIntent = url.searchParams.get("payment_intent");
      const orderId = url.searchParams.get("orderId");
      if (fromStripe && paymentIntent && orderId) {
        setB3ModalOpen(true);
        setB3ModalContentType({
          type: "anyspendOrderDetails",
          orderId
        });
        url.searchParams.delete("fromStripe");
        url.searchParams.delete("payment_intent");
        url.searchParams.delete("payment_intent_client_secret");
        url.searchParams.delete("redirect_status");
        window.history.replaceState({}, "", url.toString());
      }
    };
    t1 = [setB3ModalOpen, setB3ModalContentType];
    $[0] = setB3ModalContentType;
    $[1] = setB3ModalOpen;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2(state_0) {
  return state_0.setB3ModalContentType;
}
function _temp(state) {
  return state.setB3ModalOpen;
}